import React from 'react'

import { Steps as AntSteps } from 'antd'
import { Col, Row } from 'antd'
import { useFormikContext } from 'formik'

import './StepsStyle.less'

const { Step } = AntSteps

interface StepsObject {
  title: string
  description: string
  icon?: string
}

interface StepsProps {
  steps: Array<StepsObject>
  title?: string
  direction?: 'vertical' | 'horizontal'
  subtitle?: string
  description?: string
  current?: number
  size?: 'defualt' | 'small'
  progressDot?: boolean
  onChange?(current: number): void
  className?: string
  type?: string
}

const Steps: React.FC<StepsProps> = (props) => {
  const context = useFormikContext()

  const onChange = (current: number) => {
    alert(current)
    props.current = current
    context.setFieldValue('step', current)
  }

  return (
    <>
      <Row>
        <Col span={props.direction === 'vertical' ? 4 : 8}>
          {props.progressDot && (
            <AntSteps
              className={props.className}
              progressDot
              direction={props.direction}
              current={props.current}
              onChange={onChange}
            >
              {props.steps.map((item, index) => {
                return <Step key={index} title={item.title} description={item.description}></Step>
              })}
            </AntSteps>
          )}
          {!props.progressDot && (
            <AntSteps direction={props.direction} current={props.current} onChange={onChange}>
              {props.steps.map((item) => {
                return <Step title={item.title} description={item.description}></Step>
              })}
            </AntSteps>
          )}
        </Col>
      </Row>
    </>
  )
}
export default Steps
